module.exports = __webpack_public_path__ + "static/media/Cart.f4ccf95a.svg";